import { Box, SxProps, Theme } from '@mui/material';

// The two-dot step indicator shared by every module pricing landing's demo
// carousel (Plannings, Tareas asignadas). Only ever two steps in current
// usage (mobile/web, web/app) -- kept fixed-arity rather than a generic N-step
// carousel that nothing needs yet.
const DEMO_STEP_BASE = {
  width: '79px',
  height: '8px',
  borderRadius: '8px',
  cursor: 'pointer',
} as const;

const customStyles = {
  container: {
    display: 'flex',
    gap: '10px',
    marginBottom: '40px',
  },
  active: {
    ...DEMO_STEP_BASE,
    background: 'linear-gradient(90deg, #3E8FFA 43.56%, #4760F6 100%)',
  },
  inactive: {
    ...DEMO_STEP_BASE,
    background: '#DDE0E5',
  },
} satisfies Record<string, SxProps<Theme>>;

interface Props {
  activeIndex: 0 | 1;
  onChangeIndex: (index: 0 | 1) => void;
  testIds: [string, string];
}

export function DemoCarouselSteps({ activeIndex, onChangeIndex, testIds }: Props) {
  return (
    <Box sx={customStyles.container}>
      <Box
        sx={activeIndex === 0 ? customStyles.active : customStyles.inactive}
        component='span'
        onClick={() => onChangeIndex(0)}
        data-testid={testIds[0]}
      />
      <Box
        sx={activeIndex === 1 ? customStyles.active : customStyles.inactive}
        component='span'
        onClick={() => onChangeIndex(1)}
        data-testid={testIds[1]}
      />
    </Box>
  );
}
